import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 24px', fontFamily: 'Arial, sans-serif', color: '#333' }}>
      
      <div style={{ borderBottom: '4px solid #EC6433', paddingBottom: '24px', marginBottom: '32px' }}>
        <h1 style={{ fontSize: '32px', fontWeight: 'bold', color: '#060606', margin: '0 0 8px 0' }}>ReportFlow</h1>
        <h2 style={{ fontSize: '20px', fontWeight: 'normal', color: '#666', margin: 0 }}>Privacy Policy</h2>
      </div>

      <p style={{ color: '#666', marginBottom: '32px' }}>
        <strong>Last updated:</strong> September 3, 2026
      </p>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>Overview</h3>
        <p>ReportFlow ("we", "our", or "us") is a social media analytics reporting tool operated by Scout Media Saskatoon. This Privacy Policy explains how we collect, use, and protect information when you use our platform to generate analytics reports for your social media accounts.</p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>Information We Collect</h3>
        <p>When you connect your Facebook or Instagram account to ReportFlow, we collect the following data through the Meta API:</p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Facebook Page names and IDs</li>
          <li>Instagram Business Account names and IDs</li>
          <li>Follower and following counts</li>
          <li>Post data including captions, media type, like counts, and comment counts</li>
          <li>Page and post engagement metrics (reach, impressions, link clicks)</li>
          <li>Video view counts</li>
          <li>Access tokens required to retrieve the above data</li>
        </ul>
        <p>We also collect account information you provide directly, including your name, email address, and password when creating a ReportFlow account.</p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>How We Use Your Information</h3>
        <p>We use the data collected solely for the following purposes:</p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Generating analytics reports for your connected social media accounts</li>
          <li>Displaying historical performance data in your ReportFlow dashboard</li>
          <li>Sending automated analytics reports to your clients on your behalf</li>
          <li>Tracking follower growth and engagement trends over time</li>
        </ul>
        <p>We do not sell, rent, or share your data with third parties for marketing or advertising purposes.</p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>Data Storage and Security</h3>
        <p>Your data is stored on Railway's cloud infrastructure and is transmitted over encrypted connections (HTTPS/TLS). Access tokens are held in access-restricted database records and are used solely to retrieve analytics data from the Meta API. Account passwords are stored as one-way bcrypt hashes and are never retained in readable form. We implement industry-standard security practices to protect your information from unauthorized access.</p>
        <p>Analytics data is retained for as long as your account is active. You may request deletion of your data at any time by contacting us.</p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>Meta Platform Data</h3>
        <p>ReportFlow accesses Facebook and Instagram data through the Meta API in accordance with Meta's Platform Terms and Developer Policies. We request only the permissions necessary to provide our analytics service. We do not use Meta platform data to target advertising, sell data, or for any purpose beyond generating analytics reports.</p>
        <p>You may disconnect your Facebook or Instagram account from ReportFlow at any time through the app settings or through your Facebook account's Business Integrations settings.</p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>Data Deletion</h3>
        <p>You have the right to request deletion of all data associated with your account. To request data deletion, contact us at <a href="mailto:info@scoutsask.ca" style={{ color: '#EC6433' }}>info@scoutsask.ca</a> with the subject line "Data Deletion Request". We will process your request within 30 days.</p>
        <p>You can also disconnect individual Facebook Pages or Instagram accounts at any time through the ReportFlow dashboard, which will stop future data collection for those accounts.</p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>Your Rights</h3>
        <p>You have the right to:</p>
        <ul style={{ lineHeight: '1.8' }}>
          <li>Access the data we hold about you</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Disconnect your social media accounts at any time</li>
          <li>Export your analytics data</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>Cookies and Sessions</h3>
        <p>ReportFlow uses session cookies solely to keep you logged in while using the platform. These cookies are not used for advertising or tracking purposes and are cleared when your session ends or you log out. We do not use third-party tracking cookies.</p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>Children's Privacy</h3>
        <p>ReportFlow is intended for use by social media marketing professionals and businesses. We do not knowingly collect personal information from children under the age of 13. If you believe a child under 13 has provided us with personal information, please contact us at <a href="mailto:info@scoutsask.ca" style={{ color: '#EC6433' }}>info@scoutsask.ca</a> and we will promptly delete it.</p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', color: '#060606', borderLeft: '4px solid #EC6433', paddingLeft: '12px' }}>Contact Us</h3>
        <p>If you have any questions about this Privacy Policy or how we handle your data, please contact us:</p>
        <p>
          <strong>Scout Media Saskatoon</strong><br />
          Email: <a href="mailto:info@scoutsask.ca" style={{ color: '#EC6433' }}>info@scoutsask.ca</a><br />
          Website: <a href="https://scoutsask.ca" style={{ color: '#EC6433' }}>scoutsask.ca</a>
        </p>
      </section>

      <div style={{ borderTop: '1px solid #e0e0e0', paddingTop: '24px', marginTop: '40px', color: '#999', fontSize: '14px' }}>
        <p>© 2026 Scout Media Saskatoon. All rights reserved.</p>
      </div>

    </div>
  );
}

export default PrivacyPolicy;